import React, { memo } from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { FormattedCurrency } from '../../../../../../../components/formatted-currency';
import { PROMOTION, PromotionalPrice, type DiscountVariant } from '../promotional-price/promotional-price';
import { messages } from './messages';

type EffectiveDiscount = {
  hasDiscount: boolean;
  discountedPrice: number;
  discountPercent: number;
};

type PlanPriceProps = {
  currencyCode: string;
  price: number;
  isAnnual: boolean;
  effectiveDiscount?: EffectiveDiscount;
  discountVariant?: DiscountVariant;
};

export const PlanPrice = memo(({ currencyCode, price, isAnnual, effectiveDiscount, discountVariant = PROMOTION }: PlanPriceProps) => {
  if (effectiveDiscount?.hasDiscount) {
    return (
      <PromotionalPrice
        currencyCode={currencyCode}
        discountedPrice={effectiveDiscount.discountedPrice}
        discountPercent={effectiveDiscount.discountPercent}
        isAnnual={isAnnual}
        originalPrice={price}
        variant={discountVariant}
      />
    );
  }

  return (
    <Text
      formattedMessageValues={{
        price: <FormattedCurrency currencyCode={currencyCode} value={price} />,
      }}
      textType={TextType.H3}
      value={isAnnual ? messages.perYear : messages.perMonth}
    />
  );
});

PlanPrice.displayName = 'PlanPrice';
